import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, InputField, TableWrapper } from 'components/Global';
import { useSelector } from 'react-redux';
import { ReactComponent as DriverIcon } from 'icons/driving-wheel-icon.svg';
import { ReactComponent as CalendarIcon } from 'icons/calendar-icon.svg';
import { ReactComponent as LocationIcon } from 'icons/mappin-icon.svg';
import SelectFieldImage from 'components/Global/SelectFieldImage';
import { format, parseISO } from 'date-fns';
import TextAreaInput from 'components/Global/TextArea';

const DriverDetail = ({ confirmHandler }) => {
  const navigate = useNavigate();

  const data = useSelector((state) => state.drivers.selected);
  const approvalData = useSelector((state) => state.approvals.selected);

  const backHandler = () => {
    navigate(-1);
  };

  return (
    <div className="detail-driver">
      <TableWrapper icon={<DriverIcon fill="#009EF7" width="25px" height="25px" />} title="Driver">
        <div className="driver__wrapper">
          <h1 className="driver__title">Detail Driver</h1>
          <div className="driver__input-group">
            <InputField label="Nama" disabled value={data.name} className="input-field" />
            <InputField label="Email" disabled value={data.email} className="input-field" />
            <InputField label="No. Handphone" disabled value={data.phone} className="input-field" />
            <InputField
              label="Tanggal Lahir"
              disabled
              value={
                data?.PersonalInfos?.date_of_birth && format(parseISO(data?.PersonalInfos?.date_of_birth), 'dd/MM/yyyy')
              }
              className="input-field"
              icon={<CalendarIcon />}
              iconPosition="start"
            />
            <InputField
              label="Domisili Driver"
              disabled
              value={data?.PersonalInfos?.domicile}
              className="input-field"
            />
            <InputField
              label="Lokasi"
              disabled
              value={data?.user_location?.location_name}
              className="input-field"
              icon={<LocationIcon />}
              iconPosition="start"
            />
            <SelectFieldImage label="KTP" disabled value={data?.PersonalInfos?.ktp} />
            <SelectFieldImage label="SIM" disabled value={data?.PersonalInfos?.sim} />
            <SelectFieldImage label="Foto Selfie" disabled value={data?.PersonalInfos?.selfie} />
            <SelectFieldImage label="Surat Perjanjian" disabled value={data?.PersonalInfos?.letter_of_agreement} />
            <InputField label="Nomor Rekening" disabled value={data?.account_bank?.no_rek} className="input-field" />
            <InputField label="Nama Bank" disabled value={data?.account_bank?.nama_bank} className="input-field" />
            <InputField label="Nama Mobil" disabled value={data?.vehicle?.name} className="input-field" />
            <InputField
              label="Nomor Polisi Mobil"
              disabled
              value={data?.vehicle?.license_number}
              className="input-field"
            />
            <InputField
              label={'Tipe Paket Driver'}
              disabled
              value={data?.vehicle?.vehicle_package_id ?? 'Paket Driver'}
              className="input-field"
            />
            <InputField label="Driver ID" disabled value={data.id} className="input-field" />

            <TextAreaInput
              label="Alasan Hapus Driver"
              disabled
              value={approvalData?.data?.deleted_reason}
              className="text-area"
              style={{ height: 120 }}
            />
          </div>

          <div className="detail-order__transaction-buttons">
            <Button variant="outline" className="button" width={208} size="sm" onClick={backHandler}>
              Kembali
            </Button>

            {approvalData?.status === 'pending' ? (
              <Button className="button" width={208} size="sm" onClick={() => confirmHandler('processed')}>
                Process
              </Button>
            ) : approvalData?.status === 'processed' ? (
              <>
                <Button
                  size="sm"
                  className="button"
                  width={208}
                  variant="danger"
                  onClick={() => confirmHandler('rejected')}
                >
                  Tolak
                </Button>
                <Button className="button" width={208} size="sm" onClick={() => confirmHandler('approved')}>
                  Konfirmasi
                </Button>
              </>
            ) : null}
          </div>
        </div>
      </TableWrapper>
    </div>
  );
};

export default DriverDetail;
